import { app } from '../../../app';

app.factory('SharedAccountsService', SharedAccountsService);

/** @ngInject */
function SharedAccountsService($resource) {
    
    
    return $resource('app/rest/admin/company/:companyId/corporateserviceaccount', {
        companyId : '@companyId'
    }, {
        'createCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'updateCompanyServiceAccounts' : {
            method : 'PUT',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'getAllByCompany' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount',
            isArray : true,
            params : {
                companyId : '@companyId'
            }
        },
        'getAllByCompanyAndPublicService' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            isArray : true,
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'deleteCompanyServiceAccounts' : {
            method : 'DELETE',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id',
            params : {
                id : '@id',
                companyId : '@companyId'
            }
        },
        'shareCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/share/:saaspassId',
            params : {
                companyId : '@companyId',
                id : '@id',
                saaspassId : 'saaspassId'
            }
        },
        'unshareCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unshare/:saaspassId',
            params : {
                companyId : '@companyId',
                id : '@id',
                saaspassId : 'saaspassId'
            }
        },
        'getSaaspassUsersByCorporateServiceAccountId' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/users/:id',
            params : {
                companyId : '@companyId',
                id : '@id'
            }
        },
        'importCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/import',
            isArray : true,
            params : {
                companyId: '@companyId',
                showOtp: '@showOtp',
                showPassword: '@showPassword',
            }
        },
        'unshareSelectedCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unshare/selected',
            params : {
                companyId : '@companyId',
                id : '@id'
            }
        },
        'shareCompanyServiceAccountsWithGroup' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/sharegroup/:groupId',
            params : {
                companyId : '@companyId',
                id : '@id',
                groupId : 'groupId'
            }
        },
        'unshareCompanyServiceAccountsWithGroup' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unsharegroup/:groupId',
            params : {
                companyId : '@companyId',
                id : '@id',
                groupId : 'groupId'
            }
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-center.service.js